import { render, staticRenderFns } from "./MaintenanceDetail.vue?vue&type=template&id=bbb21cd2"
import script from "./MaintenanceDetail.vue?vue&type=script&lang=ts"
export * from "./MaintenanceDetail.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports